import React from 'react';
import { Form, Input } from 'antd';

const CustomerCustomFields = ({ custom_fields, handleCustomFieldsChange }) => {
  // Filter to only show fields with display_internal enabled
  const visibleFields = (custom_fields || []).filter(field => 
    field.display_internal === true || 
    field.display_internal === "1" || 
    field.display_internal === "true" || 
    field.display_internal === 1
  );

  if (!visibleFields || visibleFields.length === 0) {
    return null;
  }

  const handleFieldChange = (fieldTitle, value) => {
    // Find the field by title and update it
    const updatedCustomFields = custom_fields.map(field => 
      field.title === fieldTitle 
        ? { ...field, value: value }
        : field
    );
    handleCustomFieldsChange(updatedCustomFields);
  };

  return (
    <>
      {visibleFields.map((field, index) => (
        <Form.Item 
          key={index}
          label={field.title}
        >
          <Input 
            // size="large"
            value={field.value || ''}
            onChange={(e) => handleFieldChange(field.title, e.target.value)}
            placeholder={`Enter ${field.title}`}
          />
        </Form.Item>
      ))}
    </>
  );
};

export default CustomerCustomFields;

